<template>
  <div>
    <div class="sub-header">
      <div class="width-wrapper relative">
        <div class="page-title">Товары</div>

        <div class="header__save">
          <!--<a href="#" @click.prevent="" class="button button&#45;&#45;inverse">Категории</a>-->
          <!--<router-link :to="{ path: './categories/' }" class="button button&#45;&#45;inverse">Категории</router-link>-->
        </div>
      </div>
    </div>
    <div class="width-wrapper">
      <div class="table" ref="table">
        <router-view></router-view>

        <div class="filter">


            <div style="display: inline-block; vertical-align: middle; width: 300px;">
            <material-input parentClass="" label="ID или Название"
                            @inputStr="inputStr"
                            v-bind:valueStr="searchStr"
            ></material-input>
            </div>




        </div>

        <table>
          <thead>
          <tr>
            <td class="id">
              ID
            </td>
            <td class="photo">Фото</td>
            <td class="title">
              Название
            </td>
            <td class="group">
              Кластер
            </td>
            <td class="group">
              Рубрика
            </td>
            <!--<td class="cats" v-for="cat in categoriesList">{{cat.node.title}}</td>-->
          </tr>
          </thead>
          <tbody>
          <tr v-for="product in productList" :class="{'anti-facing': product.noFacing}">
            <td class="id">{{product.groupId}}</td>
            <td class="photo">
              <div class="photo-item" :style="{'background-image': `url('${product.photos.FRONT}')`}"></div>
            </td>
            <td class="title" v-on:dblclick="$router.push({ path: `/products/${product.id}`})">{{product.title}}
            </td>
            <td class="group">{{product.cluster ? product.cluster.title : ''}}</td>
            <td class="group">{{product.heading ? product.heading.title : ''}}</td>
          </tr>
          </tbody>

        </table>

        <a href="#"
           ref="nextLink"
           @click.prevent="loadNextPage"
           v-if="next != null"
        >Еще товары</a>

      </div>
    </div>
  </div>
</template>


<script type="text/javascript">
  /* eslint-disable no-unused-vars,spaced-comment */
  import Vue from 'vue';
  import lodash from 'lodash';
  import VueLodash from 'vue-lodash/dist/vue-lodash.min';
  import axios from 'axios';

  import editableTd from '../EditableTD';
  import ProductEdit from './ProductEdit';
  import MaterialInput from '../html/InputMaterial';

  Vue.use(VueLodash, lodash);

  export default {
    name: 'products-table',
    created() {
      this.load('', true);
    },
    mounted() {
      window.addEventListener('scroll', this.runOnScroll);
    },
    watch: {
      searchStr(val) {
        this.load(val, true);
      },
    },
    data() {
      return {
        searchStr: '',
        products: [],
        productList: [],
        isLoading: false,
        next: null,
      };
    },
    methods: {
      inputStr: Vue._.debounce(function mutated(input) { this.searchStr = input; }, 500),
      load(search, clearList) {
        this.loadURL(`/api/v2/products/?search=${search}`, clearList);
      },
      loadURL(url, clearList) {
        const that = this;
        axios.get(url).then((response) => {
          that.isLoading = false;
          that.makeList(response.data, clearList);
        });
      },
      makeList(response, clearList) {
        if (clearList) {
          this.productList = [];
        }
        this.next = response.next;
        if (response.results.length > 0) {
          response.results.forEach((product) => {
            const productCopy = Object.assign({}, product);
            if (product.photos.length > 0) {
              productCopy.photos = Object.assign(...product.photos.map(
                o => ({ [o.side]: o.photo50 }),
              ));
            }
            this.productList.push(productCopy);
          });
        }
      },
      runOnScroll() {
        if (this.next != null) {
          if ((this.$refs.nextLink.offsetParent.scrollTop + window.outerHeight + 150) >
            this.$refs.nextLink.offsetTop) {
            this.loadNextPage();
          }
        }
      },
      loadNextPage() {
        if (!this.isLoading && this.next != null) {
          this.isLoading = true;
          this.loadURL(this.next, false);
        }
      },
    },
    components: {
      MaterialInput,
      ProductEdit,
      editableTd },
  };
</script>

<style type="text/css" scoped>
  .filter{
    margin: 20px 0;
  }

  .filter-name{
    width: 295px;
  }

  table, td{
    padding: 0;
    margin: 0;
    border-collapse: collapse;
    border-spacing: 0;
    vertical-align: top;
    font-size: 12px;
    line-height: 16px;
    box-sizing: border-box;
  }

  thead td{
    text-align: left;
    height: 60px;
    background: #FFFFFF;
    border-bottom: 2px solid #eaeaea;
    vertical-align: middle;
  }

  td{
    padding: 15px 10px;
    height: 44px;
    vertical-align: top;
    text-align: left;
    font-family: 'Roboto', sans-serif;
    border-top:1px solid #eaeaea;
  }

  tbody td{
    /*padding: 15px 10px 0;*/
  }

  .anti-facing td{
    background: rgba(254,223,229,0.4);
    border-top-color:#EBEEF0;
  }

  .id{
    width: 60px;
    border-left:1px solid #eaeaea;
  }

  .photo{
    width: 45px;
  }

  .photo-item{
    width: 40px;
    height: 40px;
    background: #FFFFFF center no-repeat;
    text-align: center;
    background-size: contain;
  }

  .photo-item__image{
    max-height: 100%;
    max-width: 100%;
  }

  .title{
    width: 250px;
  }

  .group{
    width: 145px;
    border-right:1px solid #eaeaea;
  }

  .notInOrder{
    width: 70px;
  }


  .cats{
    background: #fcfcfc;
    min-width: 40px;
    border-right: 1px solid #eaeaea;
  }

  .sort-arrow{
    color:#ccc;
  }

</style>


// WEBPACK FOOTER //
// Products.vue?dd3c7eec